import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";

export default function FormikTextField(props) {
  const {
    disabled,
    name,
    label,
    type,
    fieldValue,
    handleChange,
    isErrorField,
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <Box className="appointment-dropdown">
      <TextField
        error={!fieldValue.value && isErrorField}
        fullWidth
        disabled={disabled}
        id={name}
        name={name}
        label={`${label}  *`}
        type={showPassword ? "text" : type} // Toggle type based on showPassword state
        className={type !== "note" && "input-field-styling required-field "}
        value={fieldValue.value}
        placeholder={label}
        onChange={handleChange}
        onBlur={fieldValue.onBlur}
        multiline={type === "note"}
        InputLabelProps={{ className: "form-field-label required-label" }}
        InputProps={{
          rows: type === "note" ? 6 : 1,
          endAdornment: type === "password" && (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={togglePasswordVisibility}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
